const getShippingSuccess = data => ({
  type: 'FETCH_SHIPPING_SUCCESS',
  payload: {
    data: data
  }
})

const fetchShipping = client => (zipCode, productSku) => {
  return (dispatch, _) => {
    dispatch({ type: 'FETCH_SHIPPING' })

    const handleSuccess = (response, zipCode) => {
      client
        .get(`v1/addresses/${zipCode}`)
        .then(responseAddress =>
          manipulateModel(response, responseAddress, zipCode)
        )
        .catch(_error => {
          dispatch({ type: 'FETCH_SHIPPING_FAIL', error: { data: _error } })
        })
    }

    const manipulateModel = ({ data }, address, zipCode) => {
      const { streetType, street, district, city, state } = address.data

      let DataEntrega = data.deliveryDate.split('T')[0]

      DataEntrega = DataEntrega.split('-')

      const model = {
        code: zipCode,
        adress: `${streetType} ${street}`,
        district: `${district}`,
        city: `${city} - ${state}`,
        shippingValue: data.total,
        shippingValueCash: data.totalCash,
        deliveryForeCastDate: `${DataEntrega[2]}/${DataEntrega[1]}/${DataEntrega[0]}`
      }

      dispatch(getShippingSuccess(model))
    }

    client
      .get(`/v2/products/sku/${productSku}/shipping/${zipCode}`)
      .then(rensponse => handleSuccess(rensponse, zipCode))
      .catch(_err => {
        dispatch({ type: 'FETCH_SHIPPING_FAIL', error: { data: _err } })
      })
  }
}

const backStateShipping = () => ({
  type: 'FETCH_BACK_SHIPPING'
})

const errorFilledShipping = () => ({
  type: 'ERROR_FILLED_SHIPPING'
})

export default client => ({
  fetchShipping: fetchShipping(client),
  backStateShipping,
  errorFilledShipping
})



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Shipping/actions.js